<template>
  <div class="warning-pendent-count">
    <svg-loader src="/static/images/icon-alert-white.svg" />
    <p>
      {{ warningMessage }} : {{ pendentWarningCount }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'WarningPendentCount',
  props: {
    pendentWarningCount: {
      required: true,
      type: Number
    },
    pendingTypes: {
      type: Array,
      default: () => ['pix', 'boletos']
    }
  },
  computed: {
    warningMessage() {
      const types = this.pendingTypes;
      
      let typesText = '';
      
      if (types.includes('pix') && types.includes('boletos')) {
        typesText = 'pix e boletos';
      } else if (types.includes('pix')) {
        typesText = 'pix';
      } else if (types.includes('boletos')) {
        typesText = 'boletos';
      }
      
      return `${typesText} que irão expirar em breve`;
    }
  }
}
</script>

<style lang="scss" scoped>
  .warning-pendent-count {
    font-family: 'Exo 2', sans-serif !important;
    width: 330px;
    height: 32px;
    background-color: #F5A623;
    padding: 0 22px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    border-radius: 4px;
    box-shadow: 0px 1px 3px 0px #00000029;

    .md-icon {
      min-width: 16px;
      min-height: 16px;
      width: 16px;
      height: 16px;
      margin: 0;
      margin-right: 7px;
    }
  }
</style>
